<div class="driver-identification-panel" [ngClass]="panelClasses">

  <div *ngIf="panelStatus$ | async as status" class="w-100 h-100 " [class.loading]="status.loading" [class.error]="status.error">

    <ng-container *ngIf="status.loading">
      <div class="w-100 h-100 d-flex flex-column gap-2 justify-content-center align-items-center">
        <div class="spinner"></div>
        <span class="">Identificación de conductores</span>
      </div>
    </ng-container>

    <ng-container *ngIf="status.error">
      <div class="w-100 h-100 d-flex flex-column gap-2 justify-content-center align-items-center">
        <i class="fas fa-exclamation"></i>
        <span>{{status.error}}</span>
      </div>
    </ng-container>

    <ng-container *ngIf="!status.loading && !status.error">
      <app-driver-selection-list [displayOnPanelFn]="toggleDisplayOnPanel.bind(this)"></app-driver-selection-list>
    </ng-container>

  </div>
</div>
